import {Box} from "@chakra-ui/react";
import {domToReact} from "html-react-parser";
import Deco from "../../../../images/decoElement.svg";
import Locked from "./images/locked.svg";
import Facebook from "../../../../images/fb_share.svg";
import LinkedIn from "../../../../images/linkedIn_share.svg";
import Twitter from "../../../../images/twitter_share.svg";
import * as React from "react";
import {useEffect} from "react";
import {unlock} from "./unlockLockedContent";

export default function SocialLockedContent({children,post,socialUnlocked}){

    useEffect(()=>{
        let sl = document.querySelector(".slc");
        let slc = document.querySelector(".locked");
        if (!sl) return;
        if (!slc) return;
        let old_slc_html = slc.innerHTML;
        slc.innerHTML = slc.innerHTML.replace(/(href=")(.*)(\")/g, "href=\"#\"");
        sl.querySelectorAll(".slc-links a").forEach(function(ele) {
            ele.onclick = function(e) {
                var web_window = window.open(this.href, 'Udostępnij link', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
                var check_window_close = setInterval(function() {
                    if (web_window.closed) {
                        clearInterval(check_window_close);
                        slc.innerHTML = old_slc_html;
                        socialUnlocked.push(post.uri);
                        if (typeof window !== 'undefined') localStorage.setItem("socialUnlocked", JSON.stringify(socialUnlocked));
                        unlock();
                    }
                }, 1000);
                e.preventDefault();
            };
        });
    })

    const lang = post.language.code ?? 'PL'

    const translations = {
        header : {
            PL: 'Treści i materiały dostępne po odblokowaniu',
            EN :'Content and materials available after unlocking'
        },
        info : {
            PL: 'Aby uzyskać dostęp udostępnij post na wybranej platformie społecznościowej.',
            EN :'Share the post on your chosen social media platform to gain access.'
        },
        infoThanks : {
            PL: 'Dziękujemy za Twoje wsparcie!',
            EN :'Thank you for your support!'
        },
        shareInfo : {
            PL: 'Udostępnij na:',
            EN :'Share on:'
        }
    }
    return (
        <Box className={'slc'} zIndex={'4'}>
            <Box className={'locked'} minHeight={{base:'650px', md:'550px', lg:'500px'}}>{domToReact(children)}</Box>
            <Box className={'slc-overlay'}>
                <Box position={'relative'}>
                    <Box as={Deco} position={'absolute'} top={'0'} right={'0'}/>
                    <Box as={Locked} />
                    <Box as={'h4'}>{translations.header[lang]}</Box>
                    <Box textAlign={'center'} fontSize={'15px'} fontWeight={'normal'} lineHeight={'26px'}>{translations.info[lang]}<br />{translations.infoThanks[lang]}</Box>
                    <Box className={'shareWithLine'}><span>{translations.shareInfo[lang]}</span></Box>
                    <Box className={'slc-links'} display={'none'}>
                        <a href={'https://www.facebook.com/sharer/sharer.php?u='+process.env.GATSBY_SITE_URL+post.uri+'%2F&amp;src=sdkpreparse'} title={'Facebook'}>
                            <Box as={Facebook} /></a>
                        <a href={'https://www.linkedin.com/sharing/share-offsite/?url='+process.env.GATSBY_SITE_URL+post.uri} title={'LinkedIn'}>
                            <Box as={LinkedIn} /></a>
                        <a href={'https://twitter.com/intent/tweet/?text=Sprawdź%20ten%20artykuł&url='+process.env.GATSBY_SITE_URL+post.uri} title={'Twitter'}>
                            <Box as={Twitter} /></a>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}